import {
  Card,
  Group,
  Stack,
  Text,
  TextInput,
  UnstyledButton,
} from '@mantine/core';
import {
  IconArrowBigLeftFilled,
  IconArrowBigRightFilled,
  IconSquareRoundedPlusFilled,
  IconTrashFilled,
} from '@tabler/icons-react';
import { useState } from 'react';
import { useClientFormContext } from '../ClientPersonalSection';

export const EmergencyContactCard = (): JSX.Element => {
  const form = useClientFormContext();

  const [curContactIndex, setCurContactIndex] = useState<number>(0);

  const handleCreateContact = (): void => {
    const newEmptyContact = {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      relation: '',
      title: '',
    };

    form.insertListItem('contacts', newEmptyContact);
    setCurContactIndex(form.values.contacts.length);
  };

  const handlePreviousContact = (): void => {
    if (curContactIndex <= 0) return;

    setCurContactIndex(curContactIndex - 1);
  };

  const handleNextContact = (): void => {
    if (curContactIndex >= form.values.contacts.length - 1) return;

    setCurContactIndex(curContactIndex + 1);
  };

  const handleDeleteContact = (): void => {
    if (form.values.contacts.length === 1) {
      // TODO: is this console error logging necessary??
      // console.error('There is only one contact - cannot delete');
      return;
    }

    form.removeListItem('contacts', curContactIndex);

    if (curContactIndex === form.values.contacts.length - 1)
      handlePreviousContact();
  };

  return (
    <Card padding="md" radius="md" withBorder>
      <Group justify="space-between">
        <Text fw={700} size="large">
          Nouzový kontakt
        </Text>
        <Group>
          <UnstyledButton onClick={handlePreviousContact} data-testid="previous button">
            <IconArrowBigLeftFilled />
          </UnstyledButton>

          <UnstyledButton onClick={handleDeleteContact} data-testid="delete button">
            <IconTrashFilled />
          </UnstyledButton>

          <UnstyledButton onClick={handleCreateContact} data-testid="add button">
            <IconSquareRoundedPlusFilled />
          </UnstyledButton>

          <UnstyledButton onClick={handleNextContact} data-testid="next button">
            <IconArrowBigRightFilled />
          </UnstyledButton>
        </Group>
      </Group>

      <Stack gap="sm" className="mt-3">
        <Group justify="space-between" grow align="start">
          <TextInput
            variant="filled"
            radius="md"
            placeholder="note"
            label="Jméno"
            data-testid="firstName-input"
            {...form.getInputProps(`contacts.${curContactIndex}.firstName`)}
          />
          <TextInput
            variant="filled"
            radius="md"
            placeholder="note"
            label="Příjmení"
            data-testid="lastName-input"
            {...form.getInputProps(`contacts.${curContactIndex}.lastName`)}
          />
        </Group>

        <Group justify="space-between" grow align="start">
          <TextInput
            variant="filled"
            radius="md"
            placeholder="note"
            label="Vztah ke klientovi"
            data-testid="relation-input"
            {...form.getInputProps(`contacts.${curContactIndex}.relation`)}
          />
          <TextInput
            variant="filled"
            radius="md"
            placeholder="note"
            label="Titul"
            data-testid="title-input"
            {...form.getInputProps(`contacts.${curContactIndex}.title`)}
          />
        </Group>

        <TextInput
          variant="filled"
          radius="md"
          placeholder="note"
          label="Telefon"
          data-testid="phone-input"
          {...form.getInputProps(`contacts.${curContactIndex}.phone`)}
        />

        <TextInput
          variant="filled"
          radius="md"
          placeholder="note"
          label="E-mail"
          data-testid="email-input"
          {...form.getInputProps(`contacts.${curContactIndex}.email`)}
        />
      </Stack>
    </Card>
  );
};
